import v14Schema, {
  MigrationTypes as V14Types,
} from "../client/schemaVersions/v14.js";
import v15Schema, {
  MigrationTypes as V15Types,
} from "../client/schemaVersions/v15.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V14Types, V15Types>(
  v14Schema,
  v15Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
